package net.sergeych.ugdx

open class UgdxError(text: String, reason: Throwable?=null): Exception(text, reason)

open class EthereumError(text: String,reason: Throwable?=null): UgdxError(text, reason)

open class InvalidOwnershipSignature(text: String = "ownership signature is not valid") : EthereumError(text)

open class InvalidOwnershipSignedMessage(text: String = "ownership message is invalid") : EthereumError(text)

open class AddressInUseError(text: String = "ownership signature is not valid") : EthereumError(text)

class OperationCancelled : UgdxError("operation has been cancelled")